<script>
    import {store} from "../store";
    import {FormatHelper} from "../../../helpers/FormatHelper";

    export default {
        data() {
            return {
                isHover: false,
                events: {},
                store: store,
            }
        },
        props: ["node", "tree", "filter", "onNodeClick"],
        methods: {
            handleItemMouseOver () {
                this.isHover = true;
            },
            handleItemMouseOut() {
                this.isHover = false;
            },
            handleItemClick(e) {

                if (e.target && e.target.className && e.target.className.indexOf('fa-chevron') > 0) {
                    return false;
                }

                this.tree.selectNode(this.tree.getNodeById(this.node.id));
                this.onNodeClick(this.tree.getNodeById(this.node.id));
            },
            toggle() {
                this.tree.toggleNode(this.tree.getNodeById(this.node.id));
            },
            highlight(value) {
                if (!this.filter) {
                    return value;
                }

                let pattern = "(" + this.filter.split("+").map((item) => {return item.trim()}).join("|") + ")",

                    result = this.filter.split("+").every((q) => {
                        return value.toLowerCase().indexOf(q.toLowerCase().trim()) >= 0;
                    });

                if (!result) {
                    return value;
                }

                return value.replace(new RegExp(pattern, 'gi'), '<span style="background-color: #338fff; color: #fff">' + '$&' + '</span>');
            },
        },
        computed: {
            getSetting() {
                return this.store.getters.setting();
            },
            getSettingViewCountWeight() {
                return this.store.getters.settingViewCountWeight();
            },
            isFolder(){
                return this.node.has_children;
            },
            isOpen(){
                return this.node.state.open;
            },
            isSelected(){
                return this.node.state.selected;
            },
            anchorClasses () {
                return [
                    {'tree-node': true},
                    {'tree-node-hovered': this.isHover},
                    {'tree-node-select': this.isSelected}
                ]
            },
            folderClasses(){
                return [
                    {'fa fa-folder-o': !this.isOpen},
                    {'fa fa-folder-open-o': this.isOpen},
                ]
            },
            chevronClasses(){
                return [
                    {'fa fa-chevron-right': !this.isOpen},
                    {'fa fa-chevron-down': this.isOpen},
                ]
            },
            childrenCount(){
                if(this.isFolder){
                    return " (" + this.node.total_flatten + ")"
                }

                return "";
            },

            it50info(){
                if(this.isFolder){
                    return this.node.sumIt50
                }

                return this.node.it50
            },
            labelInfo(){

                let result = [];
                for (let p in this.getSetting.view.treeNodeName) {
                    if (this.getSetting.view.treeNodeName[p].enabled){
                        result.push({
                            key: p,
                            color: this.getSetting.view.treeNodeName[p].color,
                            background: this.getSetting.view.treeNodeName[p].background,
                            value: FormatHelper.numberDigits(this.node[p], true, 'en'),
                            fullValue: FormatHelper.number(this.node[p], '', true),
                            width: this.getSettingViewCountWeight[p]
                        });
                    }
                }

                return result.reverse();
            },
        },
        created () {
            const events = {
                'mouseover': this.handleItemMouseOver,
                'mouseout': this.handleItemMouseOut,
            };
            this.events = events;
            this.node.state['selected'] = false;
        },
    }
</script>

<template>
    <div @click="handleItemClick" style="user-select: none;">
        <div :class="anchorClasses" :style="{'margin-left': node.state.depth * 12 + 'px'}" v-on="events">
            <i v-if="isFolder" :class="chevronClasses" @click.prevent="toggle" aria-hidden="true" style="padding-right: 5px;"></i>
            <span v-if="!isFolder" style="padding-right: 12px;">&nbsp;</span>
            <span v-if="isFolder" :class="folderClasses" style="padding-right: 5px;"></span>
            <span v-html="highlight(node.name) + childrenCount" :title="node.name"></span>
            <div style="float: right; background: white; position: absolute; top: 1px; right: 0;">
                <span v-for="info in labelInfo" :style="{'width': info.width + 'px', 'color': info.color, 'background-color': info.background}" style="float: right;" :title="info.fullValue">
                    <span class="tree-node-info">{{info.value}}</span>
                </span>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .tree-node {
        transition: background-color .15s, box-shadow .15s;
        cursor: default;
        padding-left: 5px;
        background: transparent;
        border: 1px solid transparent;
    }
    .tree-node-info {
        display: block;
        margin: 0 5px 0 0;
        font-size: 8px;
        text-align: right;
    }
    .tree-node-hovered {
        background: #fafbfc;
    }
    .tree-node-select {
        background: #fafbfc;
        border: 1px solid #e8edf1;
    }
    .tree-node-drag-over {
        border: 1px solid #d4d4db;
        border-style: dashed;
    }
</style>
